import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useSelector } from "react-redux";
import {
  formatDateBySetting,
  convertValuesFM,
} from "../../../shared-resources/utils";

const useStyles = makeStyles({
  table: {
    width: "100%",
    border: "1px solid #000",
  },
  tableTitle: {
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#01539a",
    lineHeight: "1",
    padding: "8px",
  },
  tableRow: {},
  tableCell: {
    padding: "6px", // Reduce padding
    lineHeight: "1.2", // Adjust line height to control text positioning
    verticalAlign: "bottom", // Position text at the bottom
  },
});

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const formatData = (value, type) => {
  if (type === "date")
    return formatDateBySetting(new Date(value.replace(/-/g, "/")), dateFormat);

  if (type === "currency") return `${convertValuesFM(value)}`;

  if (type === "percentage") return `${value.toFixed(2)}%`;

  return value;
};

const costPointRowDefs = [
  { key: "revenue", display: "Revenue", type: "currency" },
  { key: "directCost", display: "Direct Costs", type: "currency" },
  { key: "grossProfit", display: "Gross Profit", type: "currency" },
  { key: "grossMargin", display: "Gross Margin %", type: "percentage" },
  { key: "indirectCost", display: "Indirect Costs", type: "currency" },
  { key: "totalCost", display: "Total Costs", type: "currency" },
  { key: "netProfit", display: "Net Profit / Fee", type: "currency" },
  {
    key: "netMargin",
    display: "Net Margin %",
    type: "percentage",
  },
];

export default function ContractSummary() {
  const classes = useStyles();

  const { data } = useSelector((state) =>
    state.financialManagementReducer.contractSummaryCostPlusData
      ? state.financialManagementReducer.contractSummaryCostPlusData
      : ""
  );

  const findData = (updatedData, projectFinancial, monthYear) => {
    if (!updatedData) return 0;
    const getData = updatedData.find(
      (item) => item.projectFinancial === projectFinancial
    );
    const getMonthYear = getData?.monthExpenseDetail?.find(
      (item) => item.monthYear === monthYear
    );
    return getMonthYear?.revenue;
  };

  return (
    <TableContainer>
      <Table
        className="contractSummaryTable contractSummarySecondTable"
        aria-label="simple table"
      >
        <TableHead>
          <TableRow className={classes.tableTitle}>
            <TableCell className={classes.tableTitle}>
              Project Financials
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              ITD Actuals
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Forecast(ETC)
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Est. At Completion(EAC)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {costPointRowDefs.map((row, i) =>
            row.display === "Backlog" ? (
              <TableRow key={row.key + i} className={classes.tableRow}>
                <TableCell className={classes.tableTitle}>
                  {row.display}
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            ) : (
              <TableRow key={row.key} className={classes.tableRow}>
                <TableCell
                  component="th"
                  scope="row"
                  className={classes.tableCell}
                >
                  {row.display}
                </TableCell>

                <TableCell align="right" className={classes.tableCell}>
                  {(() => {
                    const rawValue = [
                      "fundingBacklog",
                      "fundingExpendedPercentage",
                    ].includes(row.key)
                      ? findData(
                          data?.backLogDetailList,
                          row.display,
                          "ITD Actuals"
                        )
                      : findData(
                          data?.projectFinancialDetailList,
                          row.display,
                          "ITD Actuals"
                        );

                    const formattedValue = formatData(rawValue, row.type);

                    return <span title={rawValue}>{formattedValue}</span>;
                  })()}
                </TableCell>

                <TableCell align="right" className={classes.tableCell}>
                  {(() => {
                    const rawValue = [
                      "fundingBacklog",
                      "fundingExpendedPercentage",
                    ].includes(row.key)
                      ? findData(data?.backLogDetailList, row.display, "ETC")
                      : findData(
                          data?.projectFinancialDetailList,
                          row.display,
                          "ETC"
                        );

                    const formattedValue = formatData(rawValue, row.type);

                    return <span title={rawValue}>{formattedValue}</span>;
                  })()}
                </TableCell>

                <TableCell align="right" className={classes.tableCell}>
                  {(() => {
                    const rawValue = [
                      "fundingBacklog",
                      "fundingExpendedPercentage",
                    ].includes(row.key)
                      ? findData(data?.backLogDetailList, row.display, "EAC")
                      : findData(
                          data?.projectFinancialDetailList,
                          row.display,
                          "EAC"
                        );

                    const formattedValue = formatData(rawValue, row.type);

                    return <span title={rawValue}>{formattedValue}</span>;
                  })()}
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
